import { logger } from '@/utils/logger';
import { ErrorPageTemplate } from '@zopauk/react-components';
import React, { type PropsWithChildren, type ErrorInfo } from 'react';

class ErrorBoundary extends React.Component<PropsWithChildren, Record<'hasError', boolean>> {
  constructor(props: PropsWithChildren) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPageTemplate>
          <ErrorPageTemplate.FiveHundred linkUrl="/" />
        </ErrorPageTemplate>
      );
    }

    return this.props.children;
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error({
      message: 'React Error Caught by the ErrorBoundary',
      id: 'error-boundary',
      errorInfo,
      error,
    });
  }
}

export default ErrorBoundary;
